import { StoreState } from '../store-interfaces';
import { CtmAnalyticsQuery, queryToString } from '../model/CtmAnalyticsModel';

const defaultRecords = { data: [], next: null, prev: null };

export const analyticsRecordsForQuery = (
  store: StoreState,
  query: CtmAnalyticsQuery | null,
) => {
  if (query === null || !query.parentId) {
    return defaultRecords;
  }
  return store.ctmInsights.entities[queryToString(query)] || defaultRecords;
};
